// Header.vue
<template>
  <div class="global_header" :class="whiteBGFlag ? 'white_bg' : ''">
    <van-icon v-if="showLeft" @click="onBackClick" class="back" name="arrow-left" />
    <h1>{{ localProp }}</h1>
    <div v-if="isShowKefu" @click="kefuClick" class="title_kefu">
      <IconFont name="kefu" :size="50" color="#fff" />
    </div>
  </div>
  <CustomerServicePopup :show="isCanShowOneLineCustomer" @close="hiddenPop" />
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  tcFinishCurrentActivity,
  isApp,
  isAideApp,
  tcFinishCurrentAideAppActivity,
} from "@/utils/bridge/index.js";
import CustomerServicePopup from "@/components/customer/index.vue";
import $sensors from "@/utils/sensors";
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  showLeft: {
    default: true,
  },
  backStatus: {
    default: false,
  },
  isShowKefu: {
    default: false,
  },
  sourceKefu: {
    default: "",
  },
  // 白色标题背景
  whiteBGFlag: {
    default: false,
  },
  // 是否为甜瓜助手页面
  isAideApp: {
    type: Boolean,
    default: false,
  },
});
const route = useRoute();
const router = useRouter();
const emit = defineEmits(["back"]);

let isCanShowOneLineCustomer = ref(false);
// const info = tcGetAppInfo()
let localProp = ref<any>("甜瓜");

localProp.value = props.title === null ? "" : props.title || route.meta.title || "甜瓜";
const onBackClick = () => {
  // 甜瓜助手app专用
  if (isAideApp() && props.isAideApp) {
    tcFinishCurrentAideAppActivity();
  } else {
    // 之前逻辑不动
    if (props.backStatus) {
      emit("back");
    } else {
      if (!isApp() && sessionStorage.getItem("twoLevels")) {
        sessionStorage.removeItem("twoLevels");
        router.push("/");
      } else {
        tcFinishCurrentActivity();
      }
    }
  }
};
const kefuClick = () => {
  console.log("客服点击", props.sourceKefu);
  $sensors.$pc(props.sourceKefu, "客服按钮");
  isCanShowOneLineCustomer.value = true;
};

const hiddenPop = () => {
  isCanShowOneLineCustomer.value = false;
};

const renderTitle = (value: string) => {
  localProp.value = value;
};

defineExpose({
  renderTitle,
});
</script>

<style lang="scss" scoped>
.global_header {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 88px;
  padding-top: 20px;
  margin: 0;
  color: #ffffff;

  background: var(--primary);
  h1 {
    font-size: 34px;
    font-weight: 500;
    line-height: 88px;
    text-align: center;
  }

  .back {
    position: absolute;
    top: 20px;
    left: 20px;
    padding: 0 20px;
    font-size: 40px;
    line-height: 88px;
  }

  .title_kefu {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 0 20px;
    line-height: 1.6;
  }
}
.white_bg {
  color: #141c28;
  background-color: #fff;
}
</style>
